import consumer from "./consumer"
import CableReady from "cable_ready"

consumer.subscriptions.create("ReportingStatusBarsChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    if (data.cableReady) {
      // Filter out operations where the DOM element does not exist
      const validOperations = data.operations.filter((operation) => {
        return operation.selector ? document.querySelector(operation.selector) : true;
      });

      // Perform the operations only if there are valid ones
      if (validOperations.length > 0) {
        CableReady.perform(validOperations);
      }
    }
  }
});